export default "__VITE_ASSET__e2b3d2d0__$_?component__"